import { toReferencedValue, referencedNodeValue } from "../schemas/shared/valueConfig.ts";

/**
 * Return a deep copy of `value` with every node-value ReferencedValue's `nodeId`
 * rewritten via `getNewId` — used when importing/duplicating a subtree so
 * dynamic configured values follow their referenced node's new id, the same way
 * `nodeReferences`/`refs` are remapped. Configured values sit under arbitrary keys
 * (e.g. a condition/effect build config's compared-to value), so this walks
 * the whole structure rather than a single well-known key.
 */
export const repointNodeValueRefs = <T>(value: T, getNewId: (id: number) => number): T => {
  const walk = (node: unknown): unknown => {
    if (Array.isArray(node)) return node.map(walk);
    if (typeof node !== "object" || node === null) return node;
    const nodeValue = referencedNodeValue(node);
    if (nodeValue) {
      return toReferencedValue({ ...nodeValue, nodeId: getNewId(nodeValue.nodeId) });
    }
    return Object.fromEntries(Object.entries(node).map(([key, child]) => [key, walk(child)]));
  };

  return walk(value) as T;
};
